import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from './AuthContext'
import { Skeleton } from '@/components/ui/skeleton'

export function ProtectedRoute({ requireAdmin = false, requireMfa = true }) {
  const { user, loading, isAdmin, mfaEnabled, requireMfa: mfaEnforced } = useAuth()
  const location = useLocation()

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background p-8">
        <div className="w-full max-w-md space-y-4">
          <Skeleton className="h-8 w-48" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-32 w-full" />
        </div>
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />
  }

  const mustChange = Boolean(user.must_change_password)
  if (mustChange && location.pathname !== '/change-password') {
    return <Navigate to="/change-password" replace />
  }

  if (
    requireMfa &&
    mfaEnforced &&
    !mfaEnabled &&
    !mustChange &&
    location.pathname !== '/mfa/setup'
  ) {
    return <Navigate to="/mfa/setup" replace />
  }

  if (requireAdmin && !isAdmin) {
    return <Navigate to="/" replace />
  }

  return <Outlet />
}
